export enum SerologyTrackingListType {
    PendShipping = 1,
    ShippedToDonorCenter = 2,
    ShippedBackToVendor = 3,
    Completed = 4,
    Cancelled = 5
}